import { QueryHookOptions, useQuery } from '@apollo/client'
import { B2cGetLotOccupancyQuery, B2cGetLotOccupancyQueryVariables } from 'parkdepot-shared/gql/graphql'
import GET_LOT_OCCUPANCY from '@graphql/queries/getLotOccupancy.query'

const useGetLotOccupancy = (opts: QueryHookOptions<B2cGetLotOccupancyQuery, B2cGetLotOccupancyQueryVariables>) => {
    return useQuery(GET_LOT_OCCUPANCY, opts)
}

export default useGetLotOccupancy
